module.exports = {
  name: 'upcoming-events',
  listClass: 'upcoming-events-list',
  defaultLimit: 15,
  itemIndexes: 'id'
}
